import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const ForkKnifeIcon = () => (
  <svg width="17.5" height="20" viewBox="0 0 18 20" fill="none">
    <path d="M6.25 0V7.5H8.75V0H11.25V7.5C11.25 9.57 9.57 11.25 7.5 11.25V20H5V11.25C2.93 11.25 1.25 9.57 1.25 7.5V0H3.75V7.5H6.25V0ZM15 0C13.62 0 12.5 3.36 12.5 7.5C12.5 10.26 13.75 12.5 15 12.5V20H17.5V0H15Z" fill="#084820"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <ForkKnifeIcon />
          <span>Condo Eats</span>
        </div>
        <nav className="footer-links">
          <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
          <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
          <Link to="/FAQ" target="_blank" rel="noopener noreferrer">FAQ</Link>      
          <Link to="/contact" target="_blank" rel="noopener noreferrer">Contact</Link>
        </nav>
      </div>
      <div className="footer-copyright">
        <p>© 2025 Condo Eats. All rights reserved.</p>
      </div>
    </footer>
  );
}

